import { render, staticRenderFns } from "./NestEditor.vue?vue&type=template&id=4bb47a80"
import script from "./NestEditor.vue?vue&type=script&lang=js"
export * from "./NestEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports